import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormGroup,  InputGroup, FormFeedback, Input,Row, Col, Label, Alert } from 'reactstrap';

import * as Validations from '../validation/validations';
import * as FormLogic from './FormLogic'
import { run, validationRunner } from '../validation/validationRunner'
import {entityGet} from '../entity/Entity';

import font from 'font-awesome/css/font-awesome.css'; // eslint-disable-line

const fieldValidations = [
  validationRunner("ZipCode", "Postcode", Validations.required, Validations.dutchZipCode, Validations.maxLength(15)),
  validationRunner("StreetName", "Straatnaam", Validations.required, Validations.maxLength(125)),
  validationRunner("AddressNumber", "Huisnummer", Validations.required, Validations.number, Validations.maxLength(32)),
  validationRunner("AddressNumberAppendix", "Toevoeging", Validations.maxLength(32)),
  validationRunner("City", "Woonplaats", Validations.required, Validations.maxLength(64)),
  validationRunner("CountryCode", "Land", Validations.required),
]


class RegistrationFormAddressData extends Component {
  constructor(props) {
    super(props);
    this.validate = false;
    this.state = {
      validationErrors: [],
      fieldsTouched: [],
      validAddress : true,
      ZipCode: "",
      AddressNumber: "",
      AddressNumberAppendix: "",
      StreetName: "",
      City: "",
      CountryCode: "NL",
    };
    this.gettingAddress = false;

    this.getAddress = this.getAddress.bind(this);

    this.handleChange = FormLogic.handleChange.bind(this);
    this.handleChangeCapitalizeWords = FormLogic.handleChangeCapitalizeWords.bind(this);
    this.errorFor = FormLogic.errorFor.bind(this);
    this.checkInvalid = FormLogic.checkInvalid.bind(this);
    this.setFieldsTouched = FormLogic.setFieldsTouched.bind(this);
    this.handleChangeToUpper = FormLogic.handleChangeToUpper.bind(this);

    this.run = run.bind(this);
  }


  componentDidUpdate() {
    this.runValidations();
  }

  runValidations(ignoreTouched) {
    if (ignoreTouched) {
      this.validate = true;
    }
    return this.run(fieldValidations);
  }

  getAddress() {
    if (this.state.ZipCode
      && this.state.ZipCode.length > 5
      && this.state.AddressNumber
      && parseInt(Number(this.state.AddressNumber), 10) == this.state.AddressNumber // eslint-disable-line
      && this.state.CountryCode === "NL"
    ){
        const parameters = {'ZipCode': this.state.ZipCode, 'AddressNumber': this.state.AddressNumber};
        if (this.state.AddressNumberAppendix) {
          parameters.AddressNumberAppendix = this.state.AddressNumberAppendix;
        }

        this.gettingAddress = true;
        entityGet("Address", parameters, ((response) => {
          this.gettingAddress = false;
          this.setState({validAddress: response.ValidAddress})

          this.setState({City: response.City})
          this.setState({StreetName: response.StreetName})
        }), (() => {this.gettingAddress = false;}));
    }
  }

  getFormValues() {
    return {
      "StreetName" : this.state.StreetName,
      "AddressNumber" : this.state.AddressNumber,
      "AddressNumberAppendix" : this.state.AddressNumberAppendix,
      "ZipCode" : this.state.ZipCode,
      "City" : this.state.City,
      "CountryCode" : this.state.CountryCode
    }
  }

  render() {
    var addressLoadingDiv;
    if (this.gettingAddress) {
      addressLoadingDiv = (<div className="input-group-prepend">
        <span className="input-group-text"><i className="fa fa-spin fa-spinner"></i></span>
      </div>)
    } else {
      addressLoadingDiv = <div></div>
    }
    return (
      <div>
        <Row>
          <Col md={{size:3, offset:1}} />
          <Col md={6}>
            <h2>
              Adresgegevens
            </h2>
          </Col>
        </Row>

        <FormGroup row>
          <Col md={{size:3, offset:1}} >
            <Label className="Label" >Land *</Label>
          </Col>
          <Col md={7}>
            <Input
              name="CountryCode"
              type="select"
              autoComplete="ignored-123456"
              value={this.state.CountryCode}
              onChange={this.handleChange}
              onBlur={this.setFieldsTouched}
              invalid={this.checkInvalid("CountryCode")}
              className="Input">
            {this.props.countries.map((country) =>
              <option key={country.CountryCode} value={country.CountryCode}>
                {country.Country}
              </option>)  }
            </Input>
            <FormFeedback>{this.errorFor("CountryCode")}</FormFeedback>
          </Col>
        </FormGroup>
        <FormGroup row>
          <Col md={{size:3, offset:1}} >
            <Label className="Label" >Postcode *</Label>
          </Col>
          <Col md={7}>
            <Input
              name="ZipCode"
              className="Input"
              autoComplete="ignored-123456"
              value={this.state.ZipCode}
              onChange={this.handleChangeToUpper}
              onBlur={(e) => {this.getAddress(); this.setFieldsTouched(e)}}
              invalid={this.checkInvalid("ZipCode")}
              innerRef={(input) => { this.ZipCode = input; }} />
            <FormFeedback>{this.errorFor("ZipCode")}</FormFeedback>
          </Col>
        </FormGroup>
        <FormGroup row>
          <Col md={{size:3, offset:1}} >
            <Label className="Label" >Huisnummer *</Label>
          </Col>
          <Col md={7}>
            <Input
              name="AddressNumber"
              value={this.state.AddressNumber}
              onChange={this.handleChange}
              autoComplete="ignored-123456"
              onBlur={(e) => {this.getAddress(); this.setFieldsTouched(e)}}
              invalid={this.checkInvalid("AddressNumber")}
              innerRef={(input) => { this.AddressNumber = input; }}
              className="Input" />
            <FormFeedback>{this.errorFor("AddressNumber")}</FormFeedback>
          </Col>
        </FormGroup>
        <FormGroup row>
          <Col md={{size:3, offset:1}} >
            <Label className="Label" >Toevoeging</Label>
          </Col>
          <Col md={7}>
            <Input
              name="AddressNumberAppendix"
              autoComplete="ignored-123456"
              value={this.state.AddressNumberAppendix}
              onChange={this.handleChange}
              onBlur={this.setFieldsTouched}
              invalid={this.checkInvalid("AddressNumberAppendix")}
              className="Input" />
            <FormFeedback>{this.errorFor("AddressNumberAppendix")}</FormFeedback>
          </Col>
        </FormGroup>

        <FormGroup row>
          <Col md={{size:7, offset:4}} >
            <Alert color="warning" hidden={this.state.validAddress}>
              Let op: de postcode-check heeft geen resultaten opgeleverd. Controleer het adres
            </Alert>
          </Col>
        </FormGroup>


        <FormGroup row>
          <Col md={{size:3, offset:1}} >
            <Label className="Label" >Straatnaam *</Label>
          </Col>
          <Col md={7}>
            <InputGroup>
              {addressLoadingDiv}
              <Input
                name="StreetName"
                autoComplete="ignored-123456"
                value={this.state.StreetName}
                onChange={this.handleChangeCapitalizeWords}
                onBlur={this.setFieldsTouched}
                innerRef={(input) => { this.StreetName = input; }}
                invalid={this.checkInvalid("StreetName")}
                className="Input"   />

              <FormFeedback>{this.errorFor("StreetName")}</FormFeedback>
            </InputGroup>
          </Col>
        </FormGroup>
        <FormGroup row>
          <Col md={{size:3, offset:1}} >
            <Label className="Label" >Woonplaats *</Label>
          </Col>
          <Col md={7}>
            <InputGroup>
              {addressLoadingDiv}
              <Input
                name="City"
                autoComplete="ignored-123456"
                value={this.state.City}
                onChange={this.handleChangeToUpper}
                onBlur={this.setFieldsTouched}
                invalid={this.checkInvalid("City")}
                innerRef={(input) => { this.City = input; }}
                className="Input" />
              <FormFeedback>{this.errorFor("City")}</FormFeedback>
            </InputGroup>
          </Col>
        </FormGroup>
      </div>
    );
  }
}


RegistrationFormAddressData.propTypes = {
  countries: PropTypes.array.isRequired,
};


export default RegistrationFormAddressData



// WEBPACK FOOTER //
// ./src/registrationform/RegistrationFormAddressData.jsx